// // import { call, put, takeLatest } from 'redux-saga/effects';
// // import { moduleList, moduleAdd, moduleDelete, moduleUpdate, moduleUpdateStatus } from '../../helpers/api/module';
// // import {  ModulesActionTypes } from './constants';
// // // import { SubsAndModulesAction } from './action';

// // // -------------------- Worker Sagas --------------------

// // // List Modules
// // function* handleModuleList(action: any) {
// //     try {
// //         const response = yield call(moduleList, action.payload);
// //         yield put({ type:  ModulesActionTypes.MODULE_LIST_SUCCESS, payload: response.data });
// //     } catch (error: any) {
// //         yield put({ type:  ModulesActionTypes.MODULE_LIST_ERROR, payload: { error: error.message } });
// //     }
// // }

// // // Add Module
// // function* handleModuleAdd(action: any) {
// //     try {
// //         const response = yield call(moduleAdd, action.payload);
// //         yield put({ type:  ModulesActionTypes.MODULE_ADD_SUCCESS, payload: { message: response.data.message } });
// //         yield put({ type:  ModulesActionTypes.MODULE_LIST }); // refresh list
// //     } catch (error: any) {
// //         yield put({ type:  ModulesActionTypes.MODULE_ADD_ERROR, payload: { error: error.message } });
// //     }
// // }

// // // Delete Module
// // function* handleModuleDelete(action: any) {
// //     try {
// //         const response = yield call(moduleDelete, action.payload);
// //         yield put({ type:  ModulesActionTypes.MODULE_DELETE_SUCCESS, payload: { message: response.data.message } });
// //         yield put({ type:  ModulesActionTypes.MODULE_LIST }); // refresh list
// //     } catch (error: any) {
// //         yield put({ type:  ModulesActionTypes.MODULE_DELETE_ERROR, payload: { error: error.message } });
// //     }
// // }

// // // Update Module
// // function* handleModuleUpdate(action: any) {
// //     try {
// //         const response = yield call(moduleUpdate, action.payload);
// //         yield put({ type:  ModulesActionTypes.MODULE_UPDATE_SUCCESS, payload: { message: response.data.message } });
// //         yield put({ type: ModulesActionTypes.MODULE_LIST }); // refresh list
// //     } catch (error: any) {
// //         yield put({ type: ModulesActionTypes.MODULE_UPDATE_ERROR, payload: { error: error.message } });
// //     }
// // }

// // // Update Module Status
// // function* handleModuleUpdateStatus(action: any) {
// //     try {
// //         const response = yield call(moduleUpdateStatus, action.payload);
// //         yield put({ type:  ModulesActionTypes.MODULE_UPDATE_STATUS_SUCCESS, payload: { message: response.data.message } });
// //         yield put({ type:  ModulesActionTypes.MODULE_LIST }); // refresh list
// //     } catch (error: any) {
// //         yield put({ type:  ModulesActionTypes.MODULE_UPDATE_STATUS_ERROR, payload: { error: error.message } });
// //     }
// // }

// // // -------------------- Watcher Saga --------------------
// // export default function* moduleSaga() {
// //     yield takeLatest( ModulesActionTypes.MODULE_LIST, handleModuleList);
// //     yield takeLatest( ModulesActionTypes.MODULE_ADD, handleModuleAdd);
// //     yield takeLatest( ModulesActionTypes.MODULE_DELETE, handleModuleDelete);
// //     yield takeLatest( ModulesActionTypes.MODULE_UPDATE, handleModuleUpdate);
// //     yield takeLatest( ModulesActionTypes.MODULE_UPDATE_STATUS, handleModuleUpdateStatus);
// // }

// import { call, put, takeLatest } from 'redux-saga/effects';
// import { moduleList, moduleAdd, moduleDelete, moduleUpdate, moduleUpdateStatus } from '../../helpers/api/module';
// import { ModulesActionTypes } from './constants';

// function* handleModuleList(action: any): Generator<any, any, any> {
//     try {
//         const response = yield call(moduleList, action.payload);
//         yield put({ type: ModulesActionTypes.MODULE_LIST_SUCCESS, payload: response.data });
//     } catch (error: any) {
//         yield put({ type: ModulesActionTypes.MODULE_LIST_ERROR, payload: { error: error.message } });
//     }
// }

// function* handleModuleAdd(action: any): Generator<any, any, any> {
//     try {
//         const response = yield call(moduleAdd, action.payload);
//         yield put({ type: ModulesActionTypes.MODULE_ADD_SUCCESS, payload: { message: response.data.message } });
//         yield put({ type: ModulesActionTypes.MODULE_LIST });
//     } catch (error: any) {
//         yield put({ type: ModulesActionTypes.MODULE_ADD_ERROR, payload: { error: error.message } });
//     }
// }

// function* handleModuleDelete(action: any): Generator<any, any, any> {
//     try {
//         const response = yield call(moduleDelete, action.payload);
//         yield put({ type: ModulesActionTypes.MODULE_DELETE_SUCCESS, payload: { message: response.data.message } });
//         yield put({ type: ModulesActionTypes.MODULE_LIST });
//     } catch (error: any) {
//         yield put({ type: ModulesActionTypes.MODULE_DELETE_ERROR, payload: { error: error.message } });
//     }
// }

// function* handleModuleUpdate(action: any): Generator<any, any, any> {
//     try {
//         const response = yield call(moduleUpdate, action.payload);
//         yield put({ type: ModulesActionTypes.MODULE_UPDATE_SUCCESS, payload: { message: response.data.message } });
//         yield put({ type: ModulesActionTypes.MODULE_LIST });
//     } catch (error: any) {
//         yield put({ type: ModulesActionTypes.MODULE_UPDATE_ERROR, payload: { error: error.message } });
//     }
// }

// function* handleModuleUpdateStatus(action: any): Generator<any, any, any> {
//     try {
//         const response = yield call(moduleUpdateStatus, action.payload);
//         yield put({
//             type: ModulesActionTypes.MODULE_UPDATE_STATUS_SUCCESS,
//             payload: { message: response.data.message },
//         });
//         yield put({ type: ModulesActionTypes.MODULE_LIST });
//     } catch (error: any) {
//         yield put({ type: ModulesActionTypes.MODULE_UPDATE_STATUS_ERROR, payload: { error: error.message } });
//     }
// }

// export default function* moduleSaga(): Generator {
//     yield takeLatest(ModulesActionTypes.MODULE_LIST, handleModuleList);
//     yield takeLatest(ModulesActionTypes.MODULE_ADD, handleModuleAdd);
//     yield takeLatest(ModulesActionTypes.MODULE_DELETE, handleModuleDelete);
//     yield takeLatest(ModulesActionTypes.MODULE_UPDATE, handleModuleUpdate);
//     yield takeLatest(ModulesActionTypes.MODULE_UPDATE_STATUS, handleModuleUpdateStatus);
// }

import { call, put, takeLatest } from 'redux-saga/effects';
import { moduleList, moduleAdd, moduleDelete, moduleUpdate, moduleUpdateStatus } from '../../helpers/api/module';
import { ModulesActionTypes } from './constants';
import { ModulesAction } from './actions';

// -------------------- Worker Sagas --------------------

// List Modules
function* handleModuleList(action: ModulesAction): Generator<any, any, any> {
    try {
        const response = yield call(moduleList, action.payload || {});
        yield put({
            type: ModulesActionTypes.MODULE_LIST_SUCCESS,
            payload: response.data, // should be Module[]
        });
    } catch (error: any) {
        yield put({
            type: ModulesActionTypes.MODULE_LIST_ERROR,
            payload: { error: error.message },
        });
    }
}

// Add Module
function* handleModuleAdd(action: ModulesAction): Generator<any, any, any> {
    try {
        const response = yield call(moduleAdd, action.payload);
        yield put({
            type: ModulesActionTypes.MODULE_ADD_SUCCESS,
            payload: { message: response.data.message },
        });
        // yield put({ type: ModulesActionTypes.MODULE_LIST });
    } catch (error: any) {
        yield put({
            type: ModulesActionTypes.MODULE_ADD_ERROR,
            payload: { error: error.message },
        });
    }
}

// Delete Module
function* handleModuleDelete(action: ModulesAction): Generator<any, any, any> {
    try {
        // backend expects { module_id: 'uuid' }
        const response = yield call(moduleDelete, action.payload);
        yield put({
            type: ModulesActionTypes.MODULE_DELETE_SUCCESS,
            payload: { message: response.data.message },
        });
        // yield put({ type: ModulesActionTypes.MODULE_LIST });
    } catch (error: any) {
        yield put({
            type: ModulesActionTypes.MODULE_DELETE_ERROR,
            payload: { error: error.message },
        });
    }
}

// Update Module
function* handleModuleUpdate(action: ModulesAction): Generator<any, any, any> {
    try {
        const response = yield call(moduleUpdate, action.payload);
        yield put({
            type: ModulesActionTypes.MODULE_UPDATE_SUCCESS,
            payload: { message: response.data.message },
        });
        // yield put({ type: ModulesActionTypes.MODULE_LIST });
    } catch (error: any) {
        yield put({
            type: ModulesActionTypes.MODULE_UPDATE_ERROR,
            payload: { error: error.message },
        });
    }
}

// Update Module Status
function* handleModuleUpdateStatus(action: ModulesAction): Generator<any, any, any> {
    try {
        const response = yield call(moduleUpdateStatus, action.payload);
        yield put({
            type: ModulesActionTypes.MODULE_UPDATE_STATUS_SUCCESS,
            payload: { message: response.data.message },
        });
        // yield put({ type: ModulesActionTypes.MODULE_LIST });
    } catch (error: any) {
        yield put({
            type: ModulesActionTypes.MODULE_UPDATE_STATUS_ERROR,
            payload: { error: error.message },
        });
    }
}

// -------------------- Watcher Saga --------------------
export default function* moduleSaga(): Generator {
    yield takeLatest(ModulesActionTypes.MODULE_LIST, handleModuleList);
    yield takeLatest(ModulesActionTypes.MODULE_ADD, handleModuleAdd);
    yield takeLatest(ModulesActionTypes.MODULE_DELETE, handleModuleDelete);
    yield takeLatest(ModulesActionTypes.MODULE_UPDATE, handleModuleUpdate);
    yield takeLatest(ModulesActionTypes.MODULE_UPDATE_STATUS, handleModuleUpdateStatus);
}
